import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import ImportTypeService from "../../services/importType/ImportTypeService";
import { loadingImportTypeDropdown } from "../../store/slices/importType/importTypeSlice";

export const useImportType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { importTypeDropdown } = useSelector(
    (state: RootState) => state.importType
  );

  const fetchImportTypeDropdown = async () => {
    try {
      const response = await ImportTypeService.fetchDropdown();
      dispatch(loadingImportTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar import types:", error);
    }
  };

  return {
    importTypeDropdown,
    fetchImportTypeDropdown,
  };
};
